module.exports = __webpack_public_path__ + "static/media/Rectangle 119.3853653f.png";